module.exports = __webpack_public_path__ + "img/windows_download_fqa.150f83ef.png";